import { DATADOG_ACTIONS } from '@cartwhl/tracking/datadogConstants';
import { useState } from 'react';

import { stashPendingSignupInfo } from '@cartwhl/common/utils';
import Checkbox from '@cartwhl/ui/atoms/Checkbox';
import Select from '@cartwhl/ui/atoms/Select';
import Text from '@cartwhl/ui/base/Text';
import GoButton from '@cartwhl/ui/input/GoButton';

import { authStore } from 'stores/global';

import {
  INDUSTRY_FOCUS_OPTIONS,
  PRODUCT_FOCUS_OPTIONS,
} from './signupQuestionOptions';

const industryFocusLeftColumnCount = Math.ceil(
  INDUSTRY_FOCUS_OPTIONS.length / 2,
);
const industryFocusLeftColumn = INDUSTRY_FOCUS_OPTIONS.slice(
  0,
  industryFocusLeftColumnCount,
);
const industryFocusRightColumn = INDUSTRY_FOCUS_OPTIONS.slice(
  industryFocusLeftColumnCount,
);

export default function SignupGoogleForm() {
  const [industryFocus, setIndustryFocus] = useState('');
  const [productFocus, setProductFocus] = useState('');

  const canContinue = industryFocus !== '' && productFocus !== '';

  function renderIndustryFocusOption(
    option: (typeof INDUSTRY_FOCUS_OPTIONS)[number],
  ) {
    const optionValue = option.value.toString();
    const optionLabel =
      typeof option.label === 'string' ? option.label : optionValue;

    return (
      <Checkbox
        key={optionValue}
        id={`signup-industry-focus-${optionValue}`}
        variant="radio"
        align="start"
        checked={industryFocus === optionValue}
        label={optionLabel}
        className="items-start gap-3 [&>button]:shrink-0"
        labelClassName="min-w-0 flex-1 pt-1 text-pretty"
        setChecked={(checked) => {
          if (checked) {
            setIndustryFocus(optionValue);
          }
        }}
      />
    );
  }

  return (
    <div className="flex flex-col gap-6 pb-7">
      <div className="flex flex-col gap-2.5">
        <Text
          as="p"
          variant="studio/body/medium/sm"
          className="text-gray-90 dark:text-white"
        >
          What do you create?
        </Text>
        <div
          role="radiogroup"
          aria-label="What do you create?"
          className="border-primary flex gap-6 rounded-2xl border bg-transparent px-5 pb-7 pt-7"
        >
          <div className="flex flex-1 flex-col gap-5">
            {industryFocusLeftColumn.map(renderIndustryFocusOption)}
          </div>
          <div className="flex flex-1 flex-col gap-5">
            {industryFocusRightColumn.map(renderIndustryFocusOption)}
          </div>
        </div>
      </div>

      <Text
        as="label"
        variant="studio/body/medium/sm"
        className="text-gray-90 flex flex-col gap-2.5 dark:text-white"
      >
        Where will your motion end up?
        <Select
          value={productFocus}
          onValueChange={setProductFocus}
          placeholder="Select an option"
          items={PRODUCT_FOCUS_OPTIONS}
          itemVariant="subtle"
        />
      </Text>

      <div className="flex justify-end">
        <GoButton
          type="button"
          data-dd-action-name={DATADOG_ACTIONS.CONTINUE_WITH_GOOGLE}
          active={canContinue}
          disabled={!canContinue}
          className="min-w-[120px]"
          onClick={() => {
            stashPendingSignupInfo({ industryFocus, productFocus });
            void authStore.continueWithGoogle();
          }}
        >
          Continue
        </GoButton>
      </div>
    </div>
  );
}
